'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Avatar, Box, Center, Divider, Text } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { logoutAction } from '@/actions/logout';
import { useUserStore } from '@/shared/stores/userStore';
import { userLinks } from '@/app/components/shell/navbar/links';
import { useTranslation } from '@/i18n/client';
import classes from './LeftMenu.module.css';

export function LeftMenu() {
  const { user, unsetUser } = useUserStore((state) => state);
  const { t } = useTranslation('links');
  const path = usePathname();

  const logout = async () => {
    await logoutAction();
    unsetUser();
  };

  const links = userLinks.map((item) => (
    <Link
      className={classes.link}
      data-active={path.includes(item.link) || undefined}
      href={item.link}
      key={item.label}
    >
      <item.icon className={classes.linkIcon} stroke={1.6} />
      <span>{t(item.label)}</span>
      {item.link === '/cabinet/support' && user && user.support.length > 0 && (
        <span className={classes.support}>{user.support.length}</span>
      )}
    </Link>
  ));

  return (
    <nav className={classes.navbar}>
      <Center>
        <Avatar my={15} size='140px' src={user?.avatar}></Avatar>
      </Center>
      <Text c='rgb(150, 150, 255)' size='30px' style={{ textAlign: 'center', fontWeight: 500 }}>
        {user?.name}
      </Text>
      <Text size='lg' mt={8} style={{ textAlign: 'center' }}>
        {user?.email}
      </Text>
      <Divider mt={15} mb={25} />
      <Box className={classes.navbarMain}>{links}</Box>
      <Box className={classes.footer}>
        <a href='#' className={classes.link} onClick={logout}>
          <IconLogout className={classes.linkIcon} stroke={1.5} />
          <span>{t('Logout')}</span>
        </a>
      </Box>
    </nav>
  );
}

export default LeftMenu;
